<template lang="pug">
    include ../helpers/pug/mixins
    +b.ARTICLE.rsl-card-item
        +e.I.count-number(v-if='index') {{ index + 1 }}
        +e.content
            +e.inner
                +e.left
                    +e.composition
                        +e.H4.composition-name(v-html='authorInfo')
                        +e.P.composition-desc(v-html='cardTitle')
                        +e.composition-corner
                +e.right
                    +e.HEADER.header
                        +e.H4.title(v-html='item.authorInfo')
                        +e.desc
                            p(v-html='item.mainInfo')
                    +e.SECTION.themes(v-if="options.themesIsVisible")
                        +e.H4.themes-title.__subtitle Темы:
                        +e.themes-content
                            +e.UL.themes-list(
                            v-for='(themes, index) in themes',
                            v-bind:key="'themesList' + index"
                            )
                                +e.LI.themes-item(
                                v-for='(item, index) in themes'
                                v-bind:key="'themesLink' + index"
                                )
                                    +e.SPAN.themes-link(
                                    v-on:click="$emit('change-themes', item)"
                                    ) {{ item.name }} #[span(v-if='index < themes.length - 1') --]
                            +e.BUTTON(type='button').themes-more.__btn(
                            v-on:click='toggleThemes'
                            v-if='themes.length > 1'
                            )  {{ toggleText }}
            +e.sub-info
                +e.BUTTON.show-more.__btn(
                type='button'
                v-on:click='toggleInfo'
                v-bind:class="{'rsl-card-item__show-more_up' : isInfoVisible }"
                ) {{ t.moreInfo }}
                +e.info(v-show='isInfoVisible')
                    +e.table
                        +e.row(v-for='row, index in visibleTableData')
                            +e.table-left
                                +e.H4.subtitle {{ row.title }}
                            +e.table-right
                                template(v-if="Array.isArray(row.content)")
                                    p(
                                    v-for='(content, index) in row.content'
                                    v-html='content'
                                    v-bind:key="'content' + index"
                                    )
                                template(v-else-if="row.btnAction")
                                    +e.btn(
                                    type='button'
                                    v-on:click="getDetailInfo(row.btnAction)"
                                    )  {{ t.seeRelDocument }}
                                template(v-else)
                                    p {{ row.content }}

            +e.quotes-content(v-if='item.snippets.length')
                +e.H5.quotes-title {{ t.quotesFromText }}
                +e.quotes-table-wrapper
                    +e.quotes-button(v-on:click='setQuotesModal')
                        +e.TABLE.quotes-table
                            tbody
                                +e.quotes-row(
                                v-for='(snippet, index) in item.snippets',
                                v-bind:key="'quote' + index"
                                )
                                    +e.quotes-table-cell {{t.pageNumber}} {{snippet.page}}
                                    +e.quotes-table-cell
                                        cite(v-html='snippet.fragment')

        +e.NAV.navigation(v-if='isNavigationVisible')
            +e.UL.nav-list
                +e.LI.nav-item(
                v-for="navItem, index in visibleNavigation"
                v-bind:key="'navItem' + index"
                )
                    template(v-if="navItem.href")
                        +e.A.nav-button(
                        v-bind:class="navItem.modif"
                        v-bind:href="navItem.href"
                        target="_blank"
                        )
                            +e.SVG.nav-svg( v-if="navItem.icon")
                                use(v-bind:xlink:href='navItem.icon')
                            +e.B.nav-button-text  {{ navItem.title }}

                    template(v-else-if="navItem.routerLink")
                        +e.ROUTER-LINK.nav-button(
                        v-bind:class="navItem.modif"
                        v-bind:to="{name: navItem.routerLink.name, params: navItem.routerLink.params}"
                        )
                            +e.B.nav-button-text {{ navItem.title }}

                    template(v-else-if="navItem.btnAction")
                        +e.BUTTON.nav-button(
                        type='button'
                        v-on:click='navItem.btnAction'
                        )
                            +e.SVG.nav-svg(v-if="navItem.icon")
                                use(v-bind:xlink:href='item.icon')

                            +e.B.nav-button-text {{ navItem.title }}

                    template(v-else)
                        +e.B.nav-button-text {{ navItem.title }}

</template>

<script>
    export default {
        props: {
            /**
             * Основные опции компоненты, влияют на его корневую логику
             * Объект выглядит следующим образом:
             * @param {String} cardLink - Ссылка на карточку произведения.
             * Если ссылка была не передана, то вместо ссылки на ее месте отображается кнопка
             * которую можно использовать для модального окна.
             * @param {Object} navList - Список флагов, для переключения состояния разных
             * навигационных кнопок и ссылок в нижнем меню
             * @param {Boolean} isLinkViewMode - Режим отображения кнопки отображение записи
             * @type {Object}
             */
            options: {
                type: Object,
                required: true,
                default() {
                    return {
                        cardLink: '',
                        themesIsVisible: false,
                        navList: {
                            readLink: true,
                            cardLink: true,
                            elOrder: true,
                            autoRef: true,
                            disser: true,
                            favorite: true,
                            propose: true
                        }
                    };
                }
            },
            /**
             * Список текстовых обозначений или переводов для текста внутри компонета
             * @type {Object}
             */
            t: {
                type: Object,
                required: false,
                default() {
                    return {
                        removeFavorite: 'Удалить из избранного',
                        addToFavorite: 'Добавить в избранное',
                        cancelReqForDig: 'Удалить запрос на оцифровку',
                        voteForDig: 'Проголосовать за оцифровку',
                        goToDiss: 'Перейти к диссертации',
                        goToAbstract: 'Перейти к автореферату',
                        elOrder: 'Электронный заказ',
                        viewRecord: 'Просмотреть запись',
                        docUnavailable: 'Недоступно для просмотра',
                        quotesFromText: 'Цитаты из текста',
                        seeRelDocument: 'Посмотреть связанные документы',
                        periodical: 'Периодика',
                        upLink: 'Входит в',
                        pageNumber: 'Номер страницы',
                        content: 'Содержание',
                        systemNumber: 'Системный номер',
                        storageLocation: 'Хранение',
                        consistOf: 'Состоит из',
                        moreInfo: 'Дополнительная информация'
                    };
                }
            },
            /**
             * Ссылка на `name` компонента, для биндинга обьекта в router-link
             * @type {String}
             */
            recordCompName: {
                type: String,
                required: false,
                default: 'RecordPage'
            },
            /**
             * Индекс текущий карточки
             * @type {Number}
             */
            index: {
                type: Number,
                required: false,
                default: null
            },
            /**
             * Объект который отображается в компоненте, и как правило приходит к нам с API
             * @type {Object}
             */
            item: {
                type: Object,
                required: true,
                default: null
            },
            /**
             * Принимает на вход объект иконок, которые потом
             * будут отображаться в компоненте. Передавать нужно ID иконки
             * в виде строки, который потом будет использоваться в теге <use>
             * @type {Object}
             */
            icons: {
                type: Object,
                required: true,
                default() {
                    return {
                        document: '',
                        lock: '',
                        unlock: '',
                        favorite: '',
                        unfavorite: '',
                        glass: '',
                        more: ''
                    };
                }
            },
            /**
             * Принимает на вход пользователя с разными данными. По большей части
             * нужен для логики методов добавление и удаление пользователя
             * @type {Object}
             */
            user: {
                type: Object,
                required: false,
                default: () => {
                }
            }
        },
        data() {
            return {
                isOpenThemes: false,
                isInfoVisible: false,
                isAddFavorite: false,
                isRemoveFavorite: false,
                isAddPropose: false,
                isRemovePropose: false,
                watcherFlag: true
            };
        },
        computed: {
            tableData() {
                return [
                    {
                        isHidden: !this.item.cardContents.length,
                        title: this.t.content,
                        content: this.item.cardContents
                    },
                    {
                        title: this.t.systemNumber,
                        content: this.item.docStorageId
                    },
                    {
                        isHidden: !this.item.cardLocation,
                        title: this.t.storageLocation,
                        content: this.item.cardLocation
                    },
                    {
                        isHidden: !this.item.upRecStorageID,
                        title: this.t.upLink,
                        content:'',
                        btnAction: 'includedIn'
                    },
                    {
                        isHidden: !this.item.hasDownRecords,
                        title: this.t.consistOf,
                        content:'',
                        btnAction: 'composedFrom'
                    },
                    {
                        isHidden: !this.item.hasRs160items,
                        title: this.t.periodical,
                        content:'',
                        btnAction: 'periodicals'
                    }
                ];
            },
            visibleTableData() {
                return this.tableData.filter(data => !data.isHidden && (data.content.length || data.btnAction));
            },
            navigation() {
                return [
                    {
                        isHidden: !this.options.navList.readLink || this.item.readLink.isAccessible,
                        title: this.t.docUnavailable
                    },
                    {
                        isHidden: !this.options.navList.readLink || !this.item.readLink.isAccessible,
                        modif: 'rsl-card-item__nav-button_read',
                        icon: this.item.readLink.linkData.iconType === 'free' ? this.icons.unlock : this.icons.lock,
                        title: this.item.readLink.linkData.urlLabel,
                        href: `https://search.rsl.ru${this.item.readLink.linkData.externalUrl}`
                    },
                    {
                        isHidden: !this.options.navList.cardLink,
                        modif: 'rsl-card-item__nav-button_more',
                        icon: this.icons.more,
                        title: this.t.viewRecord,
                        href: this.searchLink
                    },
                    {
                        isHidden: !this.item.eOrderAvailable || !this.options.navList.elOrder,
                        modif: 'rsl-card-item__nav-button_el_order',
                        icon: this.icons.glass,
                        title: this.t.elOrder,
                        btnAction: () => this.makeElOrder(this.item)
                    },
                    {
                        isHidden: !this.item.autorefStorageID || !this.options.navList.autoRef,
                        modif: 'rsl-card-item__nav-button_el_order',
                        routerLink: {
                            name: [this.recordCompName],
                            params: {
                                id: this.item.autorefStorageID,
                                fromID: this.item.docStorageId
                            }
                        },
                        title: this.t.goToAbstract
                    },
                    {
                        isHidden: !this.item.disserStorageID || !this.options.navList.disser,
                        modif: 'rsl-card-item__nav-button_el_order',
                        routerLink: {
                            name: [this.recordCompName],
                            params: {
                                id: this.item.disserStorageID,
                                fromID: this.item.docStorageId
                            }
                        },
                        title: this.t.goToDiss
                    },
                    {
                        isHidden: this.isAddPropose
                            || (this.item.hasFile && (this.item.hasDownRecords || this.item.hasDigitalChildren))
                            || !this.options.navList.propose,
                        modif: 'rsl-card-item__nav-button_proposal',
                        btnAction: () => this.addDocumentProposal(this.item.docStorageId),
                        title: this.t.voteForDig
                    },
                    {
                        isHidden: !this.isAddPropose || !this.options.navList.propose,
                        modif: 'rsl-card-item__nav-button_proposal',
                        btnAction: () => this.deleteDocumentProposal(this.item.docStorageId),
                        title: this.t.cancelReqForDig
                    },
                    {
                        isHidden: !this.options.navList.favorite || (!this.item.$isAddInFavorite || !this.isAddFavorite),
                        modif: 'rsl-card-item__nav-button_favorite',
                        icon: this.icons.favorite,
                        btnAction: () => this.deleteFavoriteDocument(this.item.docStorageId),
                        title: this.t.addToFavorite
                    },
                    {
                        isHidden: !this.options.navList.favorite || (this.item.$isAddInFavorite || this.isAddFavorite),
                        modif: 'rsl-card-item__nav-button_favorite',
                        btnAction: () => this.addFavoriteDocument(this.item.docStorageId),
                        icon: this.icons.unfavorite,
                        title: this.t.removeFavorite
                    }
                ];
            },
            visibleNavigation() {
                return this.navigation.filter(item => !item.isHidden);
            },
            toggleText() {
                return this.isOpenThemes ? 'Свернуть' : 'Показать все';
            },
            themes() {
                return this.item.generalSystematicCatalogBranches.map((data) => {
                    const array = [];
                    function recursive(value) {
                        const { child, ...rest } = value;
                        array.push(rest);
                        if (child) {
                            recursive(value.child);
                        }
                    }
                    recursive(data);
                    return array;
                });
            },
            isAddPropsa() {
                return this.item.$isAddPropose;
            },
            isNavigationVisible() {
                return Object.values(this.options.navList).some(it => it);
            },
            authorInfo() {
                const title = this.item.cardAuthor;

                if (title.length >= 30) {
                    return `${title.substring(0, 30)}...`;
                }

                return title;
            },
            cardTitle() {
                const title = this.item.cardTitle.replace(/<\/?[a-zA-Z]+>/gi, '');
                if (title.length >= 30) {
                    return `${title.substring(0, 30)}...`;
                }
                return title;
            },
            searchLink() {
                return !this.options.cardLink ? this.item.readLink.linkData.externalUrl : this.options.cardLink;
            },
            isReloadList() {
                return this.$route.query;
            }
        },
        watch: {
            isReloadList() {
                this.isInfoVisible = false;
            },
            isAddPropsa(value) {
                if (this.watcherFlag) {
                    this.isAddPropose = value;
                    this.watcherFlag = false;
                }
            }
        },
        methods: {
            addFavoriteDocument(id) {
                this.$store.dispatch('addFavoriteDocument', id)
                    .then((response) => {
                        if (response.added) {
                            this.isAddFavorite = true;
                            this.isRemoveFavorite = false;
                        }
                    })
                    .catch((error) => {
                        this.$store.dispatch('setError', {
                            body: error.response.data
                        });
                    });
            },
            deleteFavoriteDocument(id) {
                this.$store.dispatch('deleteFavoriteDocument', id)
                    .then((response) => {
                        if (response.remove) {
                            this.isRemoveFavorite = true;
                            this.isAddFavorite = false;
                        }
                    })
                    .catch((error) => {
                        this.$store.dispatch('setError', {
                            body: error.response.data
                        });
                    });
            },
            deleteDocumentProposal(id) {
                this.$store.dispatch('deleteDocumentProposal', id)
                    .then((response) => {
                        if (response.remove) {
                            this.isAddPropose = false;
                            this.isRemovePropose = true;
                        }
                    })
                    .catch((error) => {
                        this.$store.dispatch('setError', {
                            body: error.response.data
                        });
                    });
            },
            addDocumentProposal(id) {
                this.$store.dispatch('reqDocumentProposal', id)
                    .then((response) => {
                        if (response.added) {
                            this.isAddPropose = true;
                            this.isRemovePropose = false;
                        }
                    })
                    .catch((error) => {
                        this.$store.dispatch('setError', {
                            body: error.response.data
                        });
                    });
            },
            makeElOrder(item) {
                this.$emit('item:makeElOrder', item);
            },
            toggleInfo() {
                this.isInfoVisible = !this.isInfoVisible;
            },
            setQuotesModal() {
                this.$emit('item:setQuotesModal', this.item);
            },
            getDetailInfo(type) {
                this.$emit('item:getDetailInfo', {
                    item: this.item,
                    type
                });
            },
            toggleThemes() {
                this.isOpenThemes = !this.isOpenThemes;
            }
        }
    };
</script>

<style lang="sass" src="./rsl-card-item.sass"></style>
